import {
  faChartPie,
  faMoneyCheckDollar,
  faPlus,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Tooltip } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AccountGroupsCollapsible from './AccountGroupsCollapsible';
import './styles/accountGroupsList.scss';
import AccountGroupFormModal from './AccountGroupFormModal';
import { refreshAccountGroups } from '../helpers/storeHelper';
import AccountStatsModal from '../account/AccountStatsModal';
import { useNavigate } from 'react-router-dom';

interface AccountGroupsListModalsState {
  accountGroupFormModalVisible: boolean;
  accountStatsModalVisible: boolean;
}

const AccountGroupsList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [state, setState] = useState<AccountGroupsListModalsState>({
    accountGroupFormModalVisible: false,
    accountStatsModalVisible: false,
  });

  const onSaveAccountGroup = async (_mutationResponse: any) => {
    await refreshAccountGroups();
    closeModals();
  };

  const closeModals = () => {
    setState({} as any);
  };

  /*
   * base button's actions (for the buttons that would open the modals above)
   */
  const onAddAccountGroupButtonClick = () => {
    setState((state) => ({ ...state, accountGroupFormModalVisible: true }));
  };

  /*
   * View Account Stats
   */
  const accountStatsModal = state.accountStatsModalVisible && (
    <AccountStatsModal onOk={closeModals} />
  );

  const showViewStatsModal = () => {
    setState((state) => ({
      ...state,
      accountStatsModalVisible: true,
    }));
  };

  const viewStatsButton = (
    <Tooltip
      placement="topLeft"
      title={t(`account.card.stats`)}
      arrow={{ pointAtCenter: true }}
    >
      <Button
        className="entity-action-buttons__button"
        onClick={showViewStatsModal}
      >
        <FontAwesomeIcon icon={faChartPie} color="crimson" />
      </Button>
    </Tooltip>
  );

  const onGoToChecksButtonClick = (_e: any) => {
    navigate('/checks');
  };

  const goToChecksButton = (
    <Button
      className="account-groups-list__go-to-checks__button"
      onClick={onGoToChecksButtonClick}
    >
      <FontAwesomeIcon icon={faMoneyCheckDollar} color="green" size="xl" />
    </Button>
  );

  /*
   * ui
   */

  return (
    <>
      {accountStatsModal}
      {state.accountGroupFormModalVisible && (
        <AccountGroupFormModal
          onSave={onSaveAccountGroup}
          onCancel={closeModals}
        />
      )}
      <div className="account-groups-list">
        {goToChecksButton}
        <div className="account-groups-list__add-account-group">
          <Button
            className="account-groups-list__add-account-group__button"
            onClick={onAddAccountGroupButtonClick}
          >
            <FontAwesomeIcon icon={faPlus} color="green" />
            <span>{t('accountGroup.actions.add')}</span>
          </Button>
          {viewStatsButton}
        </div>
        <AccountGroupsCollapsible />
      </div>
    </>
  );
};

export default AccountGroupsList;
